(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cc-category-cards"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cc-category-slider')) {
    customElements.define(
      'cc-category-slider',
      class extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-track]');
          this.arrows = this.querySelectorAll('.cc-cats__arrow');
          if (!this.track) return;
          this.arrows.forEach((arrow) =>
            arrow.addEventListener('click', () => {
              const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
              this.track.scrollBy({ left: this.track.clientWidth * 0.8 * Number(arrow.dataset.dir), behavior: reduce ? 'auto' : 'smooth' });
            })
          );
          this.update = this.update.bind(this);
          this.track.addEventListener('scroll', this.update, { passive: true });
          window.addEventListener('resize', this.update);
          this.update();
        }

        disconnectedCallback() {
          window.removeEventListener('resize', this.update);
        }

        update() {
          const max = this.track.scrollWidth - this.track.clientWidth - 2;
          this.arrows.forEach((arrow) => {
            const dir = Number(arrow.dataset.dir);
            arrow.disabled = dir < 0 ? this.track.scrollLeft <= 2 : this.track.scrollLeft >= max;
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cc-promo-cards"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cc-promo-slider')) {
    customElements.define(
      'cc-promo-slider',
      class extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-track]');
          this.arrows = this.querySelectorAll('.cc-promo__arrow');
          if (!this.track) return;
          this.arrows.forEach((arrow) =>
            arrow.addEventListener('click', () => {
              const card = this.track.querySelector('.cc-card');
              const gap = parseFloat(getComputedStyle(this.track).columnGap) || 16;
              const step = card ? card.getBoundingClientRect().width + gap : 296;
              const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
              this.track.scrollBy({ left: step * Number(arrow.dataset.dir), behavior: reduce ? 'auto' : 'smooth' });
            })
          );
          this.update = this.update.bind(this);
          this.track.addEventListener('scroll', this.update, { passive: true });
          window.addEventListener('resize', this.update);
          this.update();
          this.setupEntrance();
          this.setupOffers();
          this.setupVideos();
        }

        setupVideos() {
          const videos = Array.from(this.querySelectorAll('.cc-card__video'));
          if (!videos.length) return;
          const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          videos.forEach((video) => {
            video.muted = true;
            video.playsInline = true;
            if (reduce) {
              video.removeAttribute('autoplay');
              video.pause();
              video.style.visibility = 'hidden';
            }
          });
          if (reduce || !('IntersectionObserver' in window)) return;
          this.videoObserver = new IntersectionObserver(
            (entries) =>
              entries.forEach((entry) => {
                const video = entry.target;
                if (entry.isIntersecting) {
                  video.play().catch(() => {});
                } else {
                  video.pause();
                }
              }),
            { threshold: 0.25 }
          );
          videos.forEach((video) => this.videoObserver.observe(video));
        }

        disconnectedCallback() {
          window.removeEventListener('resize', this.update);
          clearInterval(this.timer);
          if (this.observer) this.observer.disconnect();
          if (this.videoObserver) this.videoObserver.disconnect();
        }

        setupEntrance() {
          const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          if (reduce || window.Shopify?.designMode || !('IntersectionObserver' in window)) return;
          this.classList.add('cc-anim-ready');
          this.observer = new IntersectionObserver(
            (entries) => {
              if (entries.some((entry) => entry.isIntersecting)) {
                this.classList.add('is-visible');
                this.observer.disconnect();
              }
            },
            { threshold: 0.15 }
          );
          this.observer.observe(this);
        }

        setupOffers() {
          this.querySelectorAll('.cc-offer__copy').forEach((button) =>
            button.addEventListener('click', async () => {
              const original = button.textContent;
              try {
                await navigator.clipboard.writeText(button.dataset.copy);
              } catch (error) {
                const field = document.createElement('textarea');
                field.value = button.dataset.copy;
                document.body.append(field);
                field.select();
                document.execCommand('copy');
                field.remove();
              }
              button.textContent = button.dataset.copiedLabel || original;
              setTimeout(() => (button.textContent = original), 1800);
            })
          );

          this.offers = Array.from(this.querySelectorAll('[data-offer][data-end]'))
            .map((card) => ({ card, end: this.parseEnd(card.dataset.end) }))
            .filter((offer) => !Number.isNaN(offer.end));
          if (!this.offers.length) return;
          this.tick();
          this.timer = setInterval(() => this.tick(), 1000);
        }

        parseEnd(value) {
          const match = value.trim().match(/^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{1,2}):(\d{2}))?$/);
          if (!match) return NaN;
          const [, y, mo, d, h = '23', mi = '59'] = match;
          return new Date(Number(y), Number(mo) - 1, Number(d), Number(h), Number(mi), 59).getTime();
        }

        tick() {
          const now = Date.now();
          this.offers.forEach(({ card, end }) => {
            const timer = card.querySelector('[data-timer]');
            const ended = card.querySelector('[data-ended]');
            const left = end - now;
            if (left <= 0) {
              if (card.dataset.onEnd === 'hide') {
                card.hidden = true;
                this.update();
              } else {
                if (timer) timer.hidden = true;
                if (ended) ended.hidden = false;
                card.querySelector('.cc-offer__code')?.setAttribute('hidden', '');
              }
              return;
            }
            if (!timer) return;
            timer.hidden = false;
            const s = Math.floor(left / 1000);
            const pad = (n) => String(n).padStart(2, '0');
            timer.querySelector('[data-d]').textContent = Math.floor(s / 86400);
            timer.querySelector('[data-h]').textContent = pad(Math.floor((s % 86400) / 3600));
            timer.querySelector('[data-m]').textContent = pad(Math.floor((s % 3600) / 60));
            timer.querySelector('[data-s]').textContent = pad(s % 60);
          });
        }

        update() {
          const max = this.track.scrollWidth - this.track.clientWidth - 2;
          this.arrows.forEach((arrow) => {
            const dir = Number(arrow.dataset.dir);
            arrow.disabled = dir < 0 ? this.track.scrollLeft <= 2 : this.track.scrollLeft >= max;
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cc-way"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cc-way')) {
    customElements.define(
      'cc-way',
      class extends HTMLElement {
        connectedCallback() {
          this.cards = Array.from(this.querySelectorAll('[data-way-card]'));
          this.dots = Array.from(this.querySelectorAll('[data-way-dot]'));
          this.index = 0;
          if (this.cards.length < 2) return;
          if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
          this.dots.forEach((dot) =>
            dot.addEventListener('click', () => {
              this.show(Number(dot.dataset.wayDot));
              this.restart();
            })
          );
          this.addEventListener('mouseenter', () => this.stop());
          this.addEventListener('mouseleave', () => this.restart());
          this.addEventListener('focusin', () => this.stop());
          this.addEventListener('focusout', () => this.restart());
          this.restart();
        }

        disconnectedCallback() {
          this.stop();
        }

        stop() {
          clearInterval(this.timer);
        }

        restart() {
          this.stop();
          const seconds = parseFloat(getComputedStyle(this).getPropertyValue('--cc-interval')) || 3.5;
          this.timer = setInterval(() => this.show((this.index + 1) % this.cards.length), seconds * 1000);
        }

        show(i) {
          this.index = i;
          this.cards.forEach((card, n) => card.classList.toggle('is-active', n === i));
          this.dots.forEach((dot, n) => {
            dot.classList.toggle('is-active', n === i);
            dot.setAttribute('aria-selected', String(n === i));
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-order"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const wanted = new URLSearchParams(window.location.search).get('type');
    if (!wanted) return;
    const needle = wanted.toLowerCase();
    document.querySelectorAll('select[data-preselect]').forEach((select) => {
      const match = Array.from(select.options).find((option) => option.text.toLowerCase().includes(needle));
      if (match) select.value = match.value;
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
